import {
  GET_FORM_DIRECTIONS,
  GET_FORM_EVENT_TYPES,
  GET_FORM_GAMES,
  GET_FORM_PLATFORMS,
  GET_FORM_CHANNELS,
  GET_FORM_RESPONSIBLE,
  GET_FORM_VERSIONS,
  GET_FORM_CLASS_TAGS,
  GET_FORM_TECH_TAGS,
  GET_FORM_TYPE_TAGS,
} from '../types';
import network from '../../services/network';
import { callApi } from './utils';

export const getDirections = (...data) => {
  const action = () => network.getFormDirections(...data);
  return callApi(action, GET_FORM_DIRECTIONS);
};

export const getEventTypes = (...data) => {
  const action = () => network.getFormEvents(...data);
  return callApi(action, GET_FORM_EVENT_TYPES);
};

export const getGames = (...data) => {
  const action = () => network.getFormGames(...data);
  return callApi(action, GET_FORM_GAMES);
};

export const getPlatforms = (...data) => {
  const action = () => network.getFormPlatforms(...data);
  return callApi(action, GET_FORM_PLATFORMS);
};

export const getResponsible = (...data) => {
  const action = () => network.getFormResponsible(...data);
  return callApi(action, GET_FORM_RESPONSIBLE);
};

export const getVersions = (...data) => {
  const action = () => network.getVersions(...data);
  return callApi(action, GET_FORM_VERSIONS);
};

export const getFormChannels = (...data) => {
  const action = () => network.getChannels(...data);
  return callApi(action, GET_FORM_CHANNELS);
};

export const getClassTags = (...data) => {
  const action = () => network.getClassTags(...data);
  return callApi(action, GET_FORM_CLASS_TAGS);
};

export const getTechTags = (...data) => {
  const action = () => network.getTechTags(...data);
  return callApi(action, GET_FORM_TECH_TAGS);
};

export const getTypeTags = (...data) => {
  const action = () => network.getTypeTags(...data);
  return callApi(action, GET_FORM_TYPE_TAGS);
};
